import { toastr } from "../_components/toastr/toastr";
import { accountService } from "../_services/accounts.service";

const FALLBACK_ERROR = "Something went wrong. Please try again later";

function asText(value: unknown): string | null {
    if (typeof value === "string") {
        const text = value.trim();
        return text.length ? text : null;
    }

    if (typeof value === "number" || typeof value === "boolean")
        return String(value);

    return null;
}

function messagesFromErrors(errors: unknown): string | null {
    if (!errors || typeof errors !== "object")
        return null;

    const parts: string[] = [];
    Object.values(errors as Record<string, unknown>).forEach((value) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                const text = asText(item);
                if (text) parts.push(text);
            });
            return;
        }

        const text = asText(value);
        if (text) parts.push(text);
    });

    return parts.length ? parts.join(" ") : null;
}

function readPayload(value: any, depth = 0): string | null {
    if (value == null || depth > 6)
        return null;

    const text = asText(value);
    if (text)
        return text;

    if (typeof value !== "object")
        return null;

    const fieldErrors = messagesFromErrors(value.errors ?? value.Errors);
    if (fieldErrors)
        return fieldErrors;

    const inner = value.innerException ?? value.InnerException;
    const innerText = inner ? readPayload(inner, depth + 1) : null;
    if (innerText)
        return innerText;

    return asText(value.detail) || asText(value.Detail)
        || asText(value.Message) || asText(value.message)
        || asText(value.error) || asText(value.Error)
        || asText(value.title) || asText(value.Title);
}

export function getErrorMessage(err: any): string {
    if (err == null || err === "")
        return FALLBACK_ERROR;

    const data = err?.response?.data;
    const payload = data !== undefined && data !== null && data !== "" ? data : err;
    const message = readPayload(payload);
    if (message && !/^Request failed with status code \d+$/.test(message))
        return message;

    const statusMessage = asText(err?.message);
    if (statusMessage && !/^Request failed with status code \d+$/.test(statusMessage))
        return statusMessage;

    return message || statusMessage || FALLBACK_ERROR;
}

export function handleResponse(response: Response) {
    return response.text().then(text => {
        let data;

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }

        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                accountService.logout();
            }

            return Promise.reject(data || text);
        }
        return data;
    });
}

export function handleErrorResponse(err: any) {
    console.log(err);
    toastr.error(getErrorMessage(err));
}

export function handleErrorResponseAxios(err: any) {
    console.log(err);
    toastr.error(getErrorMessage(err));
}
